import { createAction } from 'redux-actions';

import { VIEW_PLANS_CTA_SELECTED } from 'app/features/landing/viewPlansCta/actionTypes';

const viewPlansCtaSelected = createAction(VIEW_PLANS_CTA_SELECTED);

export { viewPlansCtaSelected };
